import { Col, Collapse, Divider, Row } from "antd";
import React, { useMemo, useState } from "react";
import { ReactComponent as VersionsHiddenIcon } from "../../../img/versions_icons/versionsHidden_icon.svg";
import { ReactComponent as VersionsShownIcon } from "../../../img/versions_icons/versionsShown_icon.svg";
import { ReactComponent as DotsIcon } from "../../../img/3dots.svg";
import ToggleColumns from "../../ToggleableVersionsTable/ToggleColumns";
import { ServiceProfileView } from "../../OfferDetails/ServiceProfileView/ServiceProfileView";
import { checkIsLoading } from "../../../lib/utils";
import { getServiceProfileColumns } from "../../../containers/OfferContainer/ServiceProfileContainer/utils/getServiceProfileColumns";
import {
  fetchServiceProfileVersions,
  offeringActions,
} from "../../../store/slices/offering/offering";
import { TableColumn } from "../../../lib/interfaces";
import { IServiceProfileTableDataRecord } from "../../../containers/OfferContainer/ServiceProfileContainer/utils/types";
import { useAppDispatch, useAppSelector } from "../../..";
import { hasAccess } from "../../RolesModule/hasAccess";
import { IChangingRecordKeyNumber } from "../../../lib/types/IViewMode";
import { MENU_ADMIN_OFFERING_WRITE } from "../../../lib/const/permissions";
import HistoryAndPropertyModal from "../../HistoryAndPropertyModal/HistoryAndPropertyModal";

export const ProductsServiceProfileParams = () => {
  const dispatch = useAppDispatch();
  const {
    offer,
    serviceProfile,
    serviceProfileLoading,
    serviceProfileVersions,
    serviceProfileVersionsLoading,
  } = useAppSelector((state) => state.offering);

  const [historyModalVisible, setHistoryModalVisible] = useState(false);
  const [objectId, setObjectId] = useState<number | null>(null);

  // Колонки таблицы просмотра. Нужен общий тогглер, поэтому вынесены наверх
  const [columns, setColumns] = useState<TableColumn<IServiceProfileTableDataRecord>[]>(
    getServiceProfileColumns()
  );

  const showHistoryModal = () => {
    setHistoryModalVisible(true);
    setObjectId(serviceProfile?.id || null);
  };

  const [isVersionsOpen, setIsVersionsOpen] = useState<boolean>(false);
  const [isCollapseOpen, setIsCollapseOpen] = useState<boolean>(true);

  const toggleCollapse = () => {
    setIsCollapseOpen((prev) => !prev);
  };

  const onClickVersionIcon = (e: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    e.stopPropagation();
    if (isVersionsOpen) {
      dispatch(offeringActions.cleanServiceProfileVersions());
      setIsVersionsOpen(false);
    } else {
      serviceProfile?.id && dispatch(fetchServiceProfileVersions(serviceProfile.id));
      setIsVersionsOpen(true);
    }
  };

  // Флаг редактируемой версии [индекс в массиве версий, mode]
  const [childChangingMode, setChildChangingMode] = useState<IChangingRecordKeyNumber>();

  const changeViewMode = (params?: IChangingRecordKeyNumber) => {
    setChildChangingMode(params);
  };

  // Добавление при создании версии
  const enrichedServiceProfileVersions =
    useMemo(() => {
      if (!childChangingMode) return serviceProfileVersions;
      if (childChangingMode[1] === "add") {
        const [pos] = childChangingMode;
        const baseVersion = serviceProfileVersions[pos];
        const firstPart = serviceProfileVersions.slice(0, pos);
        const secondPart = serviceProfileVersions.slice(pos);
        return [...firstPart, baseVersion, ...secondPart];
      }
      return serviceProfileVersions;
    }, [serviceProfileVersions, childChangingMode]) || [];

  return (
    <div className="service-profile-container">
      <Divider className="service-profile-container__upperDivider" />
      <Collapse activeKey={isCollapseOpen ? ["1"] : []} bordered={false} onChange={toggleCollapse}>
        <Collapse.Panel
          key="1"
          header={
            <Row justify="space-between" className="service-profile-container__pageTitle">
              <h3>Профиль оплаты</h3>
              {isCollapseOpen && (
                <Row align="middle" gutter={7}>
                  <Col>
                    {isVersionsOpen && <VersionsShownIcon onClick={onClickVersionIcon} />}
                    {!isVersionsOpen && <VersionsHiddenIcon onClick={onClickVersionIcon} />}
                  </Col>
                  <Col>
                    <DotsIcon
                      onClick={(e) => {
                        e.stopPropagation();
                        showHistoryModal();
                      }}
                    />
                  </Col>
                </Row>
              )}
            </Row>
          }
        >
          <Divider style={{ margin: 0 }} />
          <Row justify="end" style={{ marginTop: "10px" }}>
            <ToggleColumns
              tableName="offer-service-profile-table"
              columns={columns}
              setColumns={setColumns}
            />
          </Row>
          <ServiceProfileView
            serviceProfile={serviceProfile}
            isLoading={checkIsLoading(serviceProfileLoading, serviceProfileVersionsLoading)}
            columns={columns}
          />
          {isVersionsOpen &&
            enrichedServiceProfileVersions.map((version, idx) => (
              <div key={idx}>
                {childChangingMode?.[0] !== idx && (
                  <ServiceProfileView
                    columns={columns}
                    isChild
                    changeViewMode={changeViewMode}
                    idx={idx}
                    serviceProfile={version}
                    isEditingDisabled
                    offeringStatusId={offer?.offeringStatusId}
                    isLoading={checkIsLoading(serviceProfileVersionsLoading)}
                  />
                )}
                {/* {childChangingMode?.[0] === idx && (
                  <Form
                    form={serviceProfileForm}
                    labelAlign="left"
                    onFinish={sumbitUpdateServiceProfileVersion}
                  >
                    <ServiceProfileEdit
                      viewMode={childChangingMode[1]}
                      onSubmit={serviceProfileForm.submit}
                      onCancel={() => setChildChangingMode(undefined)}
                      clearServiceProfile={clearServiceProfile}
                      serviceProfile={version}
                      offeringStatusId={offer?.offeringStatusId}
                      offer={offer}
                    />
                  </Form>
                )} */}
              </div>
            ))}
        </Collapse.Panel>
      </Collapse>
      <HistoryAndPropertyModal
        objectTypeSysname="service_billing_profile"
        objectId={objectId}
        handleHideModal={() => setHistoryModalVisible(false)}
        visibleModal={historyModalVisible}
        hasAccessToEdit={hasAccess(MENU_ADMIN_OFFERING_WRITE)}
      />
    </div>
  );
};
